module.exports = "/images/Tally.png?73567258ffa1eb876593cac7ba44f40d";